import FirstHeatSvg from '@/assets/icons/first_heat.svg?react';
import { TextWarn, WarnShoppingTextIcon } from '@/templates/ModalPark/styles';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    gap: 0.75rem;
    > div {
        background: #bfe0fb;
        color: #1e2545;

        span {
            font-weight: 500;
        }

        strong {
            font-weight: 700;
        }
    }

    button {
        flex-shrink: 0;
    }
`;

export const FirstHeatNotice = ({
    firstHeatCount,
}: {
    firstHeatCount?: number;
}) => {
    return (
        <Container>
            <WarnShoppingTextIcon>
                <FirstHeatSvg />
                <TextWarn>
                    Você tem{' '}
                    <strong>{firstHeatCount} First Heats disponíveis</strong>{' '}
                    para resgate
                </TextWarn>
            </WarnShoppingTextIcon>
            {/* <ButtonWithIcon
                variant="yellow"
                onClick={() => faqModalStore.update({ isVisible: true })}
            >
                <LuInfo />
                {!shouldHideText && <span>Informações Importantes</span>}
            </ButtonWithIcon> */}
        </Container>
    );
};
